<template>
  <div>
    <div v-if="entity" style="background-color: #F9F9F9; font-family: 'Roboto', sans-serif; font-size: 21px; font-weight: 500; padding: .5rem .75rem;">
      {{ entity.name }}
      <span v-if="isUpdating" class="float-right text-info">Updating...</span>
    </div>

    <div v-if="defaultPaymentMethod" style="padding: .5rem 1rem; background-color: rgba(46, 170, 76, .2); margin-top: 1rem; font-size: 14px;">
      <strong class="text-success">Subscription is using {{defaultPaymentMethod.cardType}} {{defaultPaymentMethod.maskedCardNumber}}</strong>
    </div>

    <input type="hidden" v-model="defaultPaymentMethodID" :name="methodInputName()" />

    <ul v-if="(subs.length > 0)" class="list-group" style="margin-top: 1rem; margin-bottom: 1rem; width: 100%; border: 1px solid #eee; color: #616161; list-style: none; padding-left: 0px; font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 400;">
      <li v-for="sub in subs" :sub="sub" :key="sub.id" class="list-group-item" style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline; border: none;">
        <div v-if="(sub.sites.length > 0)">
          {{sub.sites[0].identifier}}
          <span v-if="sub.sites[0].address_city && sub.sites[0].address_state">
            ({{sub.sites[0].address_city}}, {{sub.sites[0].address_state}})
          </span>
          <br /><small>{{sub.sites[0].address_street1}}</small>
        </div>
        <div v-else class="text-warning">No sites in this subscription</div>
      </li>
    </ul>
    <div v-if="(subs.length <= 0)" class="text-warning" style="margin-top: 1rem; margin-bottom: 2rem; width: 100%; border: 1px solid #eee; color: #616161; list-style: none; padding-left: 0px; font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 400;">
      This legal entity has no subscriptions to manage.
    </div>

    <!-- Add payment method form -->
    <div
      v-if="!defaultPaymentMethod"
      style="margin-top: 1rem; margin-bottom: 1rem; width: 100%; border: 1px solid #eee; color: #616161; font-family: 'Roboto', sans-serif; font-size: 14px; font-weight: 400; padding: .5rem 1rem;"
    >
      <payment-form
        :api-key="apiKey"
        :customer-id="customerId"
        :client-ip="clientIp"
        :email="email"
      >
      </payment-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    apiKey: { type: String, required: true },
    clientIp: { type: String, required: true },
    customerId: { type: Number, required: true },
    email: { type: String, default: '', },
    entityId: { type: Number, required: true },
    groupId: { type: Number },
  },
  data: function() {
    return {
      defaultPaymentMethod: false,
      defaultPaymentMethodID: '',
      entity: false,
      isUpdating: false,
      paymentCards: {},
      selectedPaymentMethodId: false,
      subs: {},
    };
  },
  methods: {
    methodInputName: function() { return 'paymentMethod[' + this.entityId + ']'; },
    getLegalEntity: function() {
      console.log('Fetching legal entity #' + this.entityId);
      this.isUpdating = true;
      axios.post('/api/v1/entity/' + this.entityId, {
          group: (this.groupId) ? this.groupId : false,
        })
        .then(function(response) {
          this.entity         = response.data.data;
          this.subs           = response.data.data.subscriptions;
          this.paymentCards   = response.data.data.fb_payment_methods.creditCards;

          response.data.data.fb_payment_methods.creditCards.forEach(card => {
            if(card.isDefault == true) {
              this.defaultPaymentMethod = card;
              this.defaultPaymentMethodID = card.id;
            }
          });

        }.bind(this))
        .catch(function(error) {
          this.entity = false;

          if(error.response) {
            this.errorCode = error.response.data.ErrorId;
            this.errors = error.response.data.Errors;
            console.error(error.response.data);
          }
          else { console.error(error); }
        }.bind(this))
        .finally(function() { this.isUpdating = false; }.bind(this))
    },
  },
  mounted: function() { this.getLegalEntity(); }
}
</script>